import { render, staticRenderFns } from "./CreateNewProject.vue?vue&type=template&id=2fb0a0bd&"
import script from "./CreateNewProject.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreateNewProject.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports